import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { EmployeeRequest } from 'src/app/models/employee.model';
import { ResponseObject } from 'src/app/models/response-object.model';
import { CountryService } from 'src/app/services/country.service';
import { HumanResourcesService } from 'src/app/services/human-resources.service';

@Component({
  selector: 'app-modal-hiring',
  templateUrl: './modal-hiring.component.html',
  styleUrls: ['../modal-admin-area/modal-admin-area.component.scss', './modal-hiring.component.scss']
})
export class ModalHiringComponent implements OnInit {
  @Input() isCreating = false;
  @Output() close = new EventEmitter<boolean>();
  @Input() newEmployee: EmployeeRequest = new EmployeeRequest();
  @Input() countries = [];
  @Input() warehouses = [];
  @Input() contractProfiles = [];
  @Input() citizenships = [];
  @Input() departments = [];
  @Input() towns = [];
  hiring = false;
  uploadingCSV = false;
  today: string = new Date().toISOString().split('T')[0];

  constructor(
    private countryService: CountryService,
    private toastService: ToastrService,
    private rrhhService: HumanResourcesService
  ) {

  }

  ngOnInit(): void {
    if (this.newEmployee.pais) {
      this.initialData();
    }

  }

  initialData() {
    this.setDepartments();
    this.setTowns();
  }

  setDepartments() {
    this.countryService.getDepartmentsByCountry(this.newEmployee.pais).subscribe({
      next: (response: ResponseObject) => {
        this.departments = response.data;
        this.newEmployee.departamento = this.departments[0].id;
        this.setTowns();
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    })
  }

  setTowns() {
    this.countryService.getTownsByDepartment(this.newEmployee.departamento, this.newEmployee.pais).subscribe({
      next: (response: ResponseObject) => {
        this.towns = response.data;
        this.newEmployee.municipio = this.towns[0].id;
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    })
  }

  hireEmployee() {
    this.hiring = true;
    if (this.isCreating) {
      this.rrhhService.registerEmployee(this.newEmployee).subscribe({
        next: (response: ResponseObject) => {
          this.toastService.success("Empleado registrado con exito");
          this.hiring = false;
          this.close.emit(true);
        },
        error: (error: any) => {
          this.toastService.error("Error al crear al empleado: identificador ya ingresado");
          this.hiring = false;
        }
      })
    } else {
      this.rrhhService.updateEmployee(this.newEmployee).subscribe({
        next: (response: ResponseObject) => {
          this.toastService.success("Empleado actualizado con exito");
          this.hiring = false;
          this.close.emit(true);
        },
        error: (error: HttpErrorResponse) => {
          this.toastService.error(error.error.message);
          this.hiring = false;
        }
      })
    }
  }

  uploadCSV() {
    var input = document.createElement('input');
    input.type = 'file';
    input.accept = '.csv';
    input.onchange = (e: any) => {
      var file = e.target.files[0];
      if (file) {
        if (file.size > 6 * 1024 * 1024) {
          this.toastService.error("El archivo excede el limite de 6MB");
          return;
        }
        this.uploadingCSV = true;
        this.rrhhService.uploadCsv(file).subscribe({
          next: (response: ResponseObject) => {
            if (!response.data.ok) {
              this.toastService.error(response.data.message);
            } else {
              this.toastService.success("Se ha cargado el archivo");
            }
            this.uploadingCSV = false;
          },
          error: (error: HttpErrorResponse) => {
            this.toastService.error(error.error.message);
            this.uploadingCSV = false;
          }
        });
      } else {
        this.uploadingCSV = false;
      }
    }
    input.click();
  }

  get canSave(): boolean {
    return !!(
      this.newEmployee.nombre &&
      this.newEmployee.apellido &&
      this.newEmployee.genero &&
      this.newEmployee.nacimiento &&
      this.newEmployee.citizenship &&
      this.newEmployee.identificacion &&
      this.newEmployee.direccion &&
      this.newEmployee.pais &&
      this.newEmployee.departamento &&
      this.newEmployee.municipio &&
      this.newEmployee.registerDate &&
      this.isDischargeDateValid() &&
      !this.hiring
    );
  }

  isDischargeDateValid(): boolean {
    if (!this.newEmployee.dischargeDate) {
      return true;
    }

    return this.newEmployee.dischargeDate <= this.today;
  }
}
